import { ReactElement } from 'react';

import Select from '@/common/Select';
import { SelectNavigationTypes } from '@/common/SelectNavigation/types';
import { getClasses } from '@/utils';
import { useNavigate } from 'react-router-dom';

const SelectNavigation = ({ ...props }: SelectNavigationTypes.Props): ReactElement => {
  const navigate = useNavigate();

  return (
    <Select
      {...props}
      className={getClasses('SelectNavigation', 'Common', props.className)}
      value={window.location.pathname}
      onChange={(value): void => navigate(value as string)}
    />
  );
};

export default SelectNavigation;
